import React from 'react'

const SpinnerSearch = () => {
  return (
    <div className="spinner-search-father">
      <div class="lds-ring-search">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default SpinnerSearch
